module.exports = __webpack_public_path__ + "img/logo-header.67afd6bd.png";